import { Button } from "@ad3d/ui";
import { useNavigate } from "react-router-dom";

export default function OAuthConsent() {
  const navigate = useNavigate();

  const handleAllow = () => {
    // Logic to proceed with auth
    // This is a placeholder implementation
    navigate("/");
  };

  const handleDeny = () => {
    navigate("/login");
  };

  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-8 px-4 py-8 text-center">
        <h2 className="text-2xl font-bold text-foreground">Authorization Request</h2>
        <p className="text-muted-foreground">
          The application is requesting access to your account.
        </p>
        <div className="flex gap-4 justify-center mt-6">
          <Button variant="outline" onClick={handleDeny}>Deny</Button>
          <Button onClick={handleAllow}>Allow</Button>
        </div>
      </div>
    </div>
  );
}
